export const heroBackground1Mask = {
  name: 'hero-background-1-mask',
  path: 'M0,0 H1 V0.88 C1,0.88,0.79,0.994,0.551,1 C0.313,1,0,0.894,0,0.894 V0',
};

export const heroBackground1MaskMobile = {
  name: 'hero-background-1-mask',
  path: 'M0,0 L0.999,0 L1,0.928 C1,0.928,0.792,0.975,0.553,0.986 C0.314,0.996,0.003,1,0.001,0.998 L0,0',
};

export const heroBackground1MaskChal3 = {
  name: 'hero-background-1-mask-chal3',
  path: 'M0.043,0.402 C0.06,0.17,0.147,0,0.248,0 H1 L0.944,0.732 C0.932,0.887,0.875,1,0.807,1 H0.014 C0.005,1,-0.002,0.982,0,0.962 L0.043,0.402',
};

export const heroBackground1MaskMobileChal3 = {
  name: 'hero-background-1-mask-chal3',
  path: 'M0,0.577 C0,0.258,0.142,0,0.317,0 H0.986 C0.994,0,1,0.011,1,0.026 V0.615 C1,0.828,0.905,1,0.789,1 H0.014 C0.006,1,0,0.989,0,0.974 V0.577',
};
